(function () {
  'use strict';

  let DEBOUNCE_MS = 280;
  let MIN_CHARS = 2;
  let API_URL = '/search/suggest.json';

  let dialog = document.getElementById('search-dialog');
  let inputEl = dialog && dialog.querySelector('[data-search-input]');
  let resultsEl = dialog && dialog.querySelector('[data-search-results]');
  let spinnerEl = dialog && dialog.querySelector('[data-search-spinner]');
  let openBtns = document.querySelectorAll('[data-search-open]');
  let closeBtn = dialog && dialog.querySelector('[data-search-close]');

  if (!dialog) return;

  let timer = null;
  let controller = null;

  function openDialog() {
    dialog.showModal();
    inputEl && inputEl.focus();
  }

  function closeDialog() {
    dialog.close();
    if (inputEl) {
      inputEl.value = '';
      clearResults();
    }
  }

  openBtns.forEach(function (btn) {
    btn.addEventListener('click', openDialog);
  });

  closeBtn && closeBtn.addEventListener('click', closeDialog);

  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) closeDialog();
  });

  dialog.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); closeDialog(); }
  });

  function clearResults() {
    if (!resultsEl) return;
    resultsEl.innerHTML = '';
    resultsEl.hidden = true;
  }

  function setLoading(on) {
    if (spinnerEl) spinnerEl.hidden = !on;
    if (inputEl) inputEl.setAttribute('aria-busy', String(on));
  }

  function renderProducts(items) {
    if (!items || !items.length) return '';
    let html = '<div class="ps-group">'
      + '<h3 class="ps-group__heading">' + window.__psT('search.products_heading') + '</h3>'
      + '<ul class="ps-list" role="list">';
    items.forEach(function (item) {
      let price = item.price
        ? '<span class="ps-item__price">' + formatMoney(item.price) + '</span>'
        : '';
      let img = item.featured_image && item.featured_image.url
        ? '<img src="' + item.featured_image.url.replace('{width}', '100') + '" alt="" width="50" height="50" loading="lazy" class="ps-item__img">'
        : '<div class="ps-item__img ps-item__img--placeholder"></div>';
      html += '<li>'
        + '<a href="' + item.url + '" class="ps-item">'
        + img
        + '<span class="ps-item__info">'
        + '<span class="ps-item__title">' + escapeHtml(item.title) + '</span>'
        + price
        + '</span>'
        + '</a>'
        + '</li>';
    });
    html += '</ul></div>';
    return html;
  }

  function renderPages(items, heading) {
    if (!items || !items.length) return '';
    let html = '<div class="ps-group">'
      + '<h3 class="ps-group__heading">' + heading + '</h3>'
      + '<ul class="ps-list" role="list">';
    items.forEach(function (item) {
      html += '<li><a href="' + item.url + '" class="ps-item ps-item--simple">'
        + '<span class="ps-item__title">' + escapeHtml(item.title) + '</span>'
        + '</a></li>';
    });
    html += '</ul></div>';
    return html;
  }

  function renderResults(data) {
    let resources = data.resources && data.resources.results;
    if (!resources) return clearResults();

    let html = '';
    html += renderProducts(resources.products);
    html += renderPages(resources.articles, window.__psT('search.articles_heading'));
    html += renderPages(resources.pages, window.__psT('search.pages_heading'));

    if (!html) {
      resultsEl.innerHTML = '<p class="ps-empty">' + window.__psT('search.no_results') + '</p>';
    } else {
      resultsEl.innerHTML = html;
    }
    resultsEl.hidden = false;
  }

  function doSearch(query) {
    if (controller) controller.abort();
    controller = new AbortController();

    setLoading(true);

    let params = new URLSearchParams({
      q: query,
      'resources[type]': 'product,article,page',
      'resources[limit]': '5',
      'resources[options][unavailable_products]': 'last'
    });

    fetch(API_URL + '?' + params.toString(), { signal: controller.signal })
      .then(function (r) { return r.json(); })
      .then(function (data) { setLoading(false); renderResults(data); })
      .catch(function (err) { if (err.name !== 'AbortError') setLoading(false); });
  }

  inputEl && inputEl.addEventListener('input', function () {
    clearTimeout(timer);
    let q = inputEl.value.trim();
    if (q.length < MIN_CHARS) { clearResults(); return; }
    timer = setTimeout(function () { doSearch(q); }, DEBOUNCE_MS);
  });

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    let fmt = (window.__moneyFormat || '${{amount}}').replace('{{amount}}', (cents / 100).toFixed(2));
    return fmt;
  }

  window.__psT = function (key) {
    let map = window.__psTranslations || {};
    return map[key] || key;
  };
})();
